import React from 'react';

import { SVGComponentProps } from './svg.types';

const DropDownSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 7"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <svg y="1.5">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.19072 3.70532L6.79201 1.2952C6.89647 1.18398 6.9652 1.04594 6.98985 0.897835C7.0145 0.749725 6.99402 0.597904 6.93089 0.460788C6.86777 0.323672 6.76471 0.207152 6.63421 0.12536C6.50371 0.0435693 6.35139 2.18699e-05 6.19572 0H0.802032C0.646836 0.000440287 0.495086 0.0441307 0.36508 0.125803C0.235073 0.207475 0.132362 0.323642 0.0693305 0.460295C0.00629917 0.596949 -0.0143606 0.748254 0.00984239 0.895967C0.0340454 1.04368 0.102078 1.18149 0.205736 1.29279L2.80703 3.70532C2.8947 3.79814 3.00153 3.8723 3.12066 3.92304C3.2398 3.97379 3.36862 4 3.49887 4C3.62913 4 3.75795 3.97379 3.87709 3.92304C3.99622 3.8723 4.10305 3.79814 4.19072 3.70532Z"
            fill="#55585E"
          />
        </svg>

        <rect x="9" y="0" width="7" height="2" fill={fill} />
        <rect x="9" y="3" width="7" height="2" fill={fill} />
        <rect x="9" y="6" width="7" height="2" fill={fill} />
      </svg>
    </span>
  );
};

export default DropDownSVG;
